/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import {
  REVIEW_ACTIVITY_MAX_DAYS,
  REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES,
} from '@repo/config';
import { z } from 'zod';

export const getProgressActivityV1RequestSchema = z.object({
  timezoneOffsetMinutes: z
    .number()
    .int()
    .min(-REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES)
    .max(REVIEW_FORECAST_MAX_TIMEZONE_OFFSET_MINUTES)
    .optional(),
  days: z.number().int().min(1).max(REVIEW_ACTIVITY_MAX_DAYS).optional(),
  cursor: z.string().min(1).max(32).optional(),
});

export type IGetProgressActivityV1Request = z.infer<typeof getProgressActivityV1RequestSchema>;
